import React, { useState, useEffect } from 'react'
import { usePdp } from '~/contexts/PdpContext'
import { jnstyls } from '~/utils/helpers'

import ReviewStars from '~/components/pdp/review-stars'
import { IconChevLeft, IconChevRight } from '~/components/icons/chevrons'

import * as styles from "~/styles/pdp/reviews.module.scss"

const Reviews = () => {
  const { reviews } = usePdp()

  const [pos, setPos] = useState(0)
  const [sortedReviews, setSortedReviews] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const [currSort, setCurrSort] = useState('Most Recent')

  const sortClick = (type) => {
    setCurrSort(type)
    setPos(0)

    if (type === 'Most Recent') {
      setSortedReviews(reviews)
      return
    }
    let new_revs = structuredClone(reviews)
    new_revs = new_revs.sort((a, b) => {
      if (a.rating !== b.rating) return a.rating - b.rating
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA - dateB
    })

    if (type === 'Highest Rated') new_revs = new_revs.reverse()
    setSortedReviews(new_revs)
  }

  const goTop = () => {
    const new_top = document.querySelector('[revs-wr]').offsetTop - 150
    window.scrollTo({top: new_top, behavior: 'instant'})
  }

  const openList = (e) => {
    e.stopPropagation()
    setIsOpen(!isOpen)
    window.addEventListener('click', closeList)
  }

  const closeList = (e) => {
    setIsOpen(false)
    window.removeEventListener('click', closeList)
  }

  useEffect(() => {
    setSortedReviews(reviews)
  }, [reviews])

  useEffect(() => {
    return () => {
      window.removeEventListener('click', closeList)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  return (
    <div className={styles.wrap} revs-wr={''}>
      <div className={styles.head}>
        <div className={styles.left}>
          <div className={styles.title}>
            Customer Reviews
          </div>
          <ReviewStars />
        </div>
        <div className={styles.right}>
          <div className={styles.over_cnt}>
            {reviews.length} Review{reviews.length > 1 ? 's' : ''}
          </div>
          <div className={styles.sort_wr}>
            <button 
              type="button"
              className={styles.sort_btn}
              aria-expanded={isOpen.toString()}
              aria-controls={'sort_list'}
              aria-label={'Change review sorting'}
              onClick={(e)=> openList(e)}
            >
              {currSort}
            </button>
            <ul id={'sort_list'} className={styles.sort_list} aria-hidden={(!isOpen).toString()} >
              <li>
                <button 
                  type="button"
                  className={styles.sort_item}
                  onClick={()=>sortClick('Most Recent')}
                >
                  Most Recent
                </button>
              </li>
              <li>
                <button 
                  type="button"
                  className={styles.sort_item}
                  onClick={()=>sortClick('Highest Rated')}
                >
                  Highest Rated
                </button>
              </li>
              <li>
                <button 
                  type="button"
                  className={styles.sort_item}
                  onClick={()=>sortClick('Lowest Rated')}
                >
                  Lowest Rated
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={styles.reviews}>
        {sortedReviews.slice(pos, (pos+4)).map(review =>
          <div 
            key={`revs_${review.id}`}
            className={styles.review}
          >
            <div className={styles.reviewer}>
              <p>
                {review.created}
              </p>
              <p className={styles.label}>
                {review.reviewer}
              </p>
            </div>
            <div className={styles.body}>
              <div className={styles.rating}>
                {[...Array(5)].map((_, i) => (
                  <div 
                    key={`star_${review.id}_${i}`} 
                    className={jnstyls([styles.star, i < review.rating ? styles.filled : styles.empty])}
                  >
                    ★
                  </div>
                ))}
              </div>
              <div className={styles.title}>
                {review.title}
              </div>
              <p dangerouslySetInnerHTML={{ __html: review.body }} />
            </div>
            <div className={styles.product}>
              <p className={styles.label} style={{fontWeight: 'normal'}}>
                <strong>Color:</strong> {review.color}
              </p>
              <p className={styles.label} style={{fontWeight: 'normal'}}>
                <strong>Size:</strong> {review.size}
              </p>
            </div>
          </div>
        )}
      </div>
      {sortedReviews.length > 4 && (
        <div className={styles.paginate}>
          <button
            type={'button'}
            className={styles.pagin_btn}
            disabled={pos === 0 ? 'disabled' : undefined}
            onClick={(e)=> {setPos(pos - 4); goTop()}}
          >
            <IconChevLeft />
          </button>
          <button
            type={'button'}
            className={styles.pagin_btn}
            disabled={(pos + 4 >= sortedReviews.length) ? 'disabled' : undefined}
            onClick={(e)=> {setPos(pos + 4); goTop()}}
          >
            <IconChevRight />
          </button>
        </div>
      )}
    </div>
  )
}

export default Reviews


// const centRangeLeft = (value) => {
//   if (value === -1) return 0
//   if (value === -0.5) return 25
//   if (value === 0) return 50
//   if (value === 0.5) return 75
//   return 100
// }
